module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 32
// module chunks = 0